export default __webpack_public_path__ + "static/media/Settings.540fa4ff.svg";